import {
  AttachmentFragment,
  PartialCollaborationV1AttachmentInput,
  UpdateAttachmentMutation,
  useUpdateAttachmentMutation,
  withStandardUpdateHook,
} from '@spotify/confidence-graphql';

export const useUpdateAttachment = withStandardUpdateHook<
  UpdateAttachmentMutation,
  AttachmentFragment,
  'updateAttachment',
  PartialCollaborationV1AttachmentInput
>(useUpdateAttachmentMutation, 'updateAttachment');
